import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { mapKeys } from 'lodash-es';
import type { Call } from '../../types';

type CallState = Record<number, Call>;

const initialState: CallState = {};

const callSlice = createSlice({
  name: 'call',
  initialState,
  reducers: {
    setCallsForDate(state, action: PayloadAction<Call[]>) {
      const mapped = mapKeys(action.payload, 'id') as unknown as Record<number, Call>;
      return { ...state, ...mapped };
    },
    setCallsToday(state, action: PayloadAction<Call[]>) {
      const mapped = mapKeys(action.payload, 'id') as unknown as Record<number, Call>;
      return { ...state, ...mapped };
    },
    pushCall(state, action: PayloadAction<Call>) {
      state[action.payload.id] = action.payload;
    },
  },
});

export const { setCallsForDate, setCallsToday, pushCall } = callSlice.actions;
export default callSlice.reducer;
